import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import useItems from '../../hooks/useItems';
import { getId } from '../../utils/item';
import { updateField } from '../../services/item';
import { ModalGlobal } from '../modal/modal.Global';
import {
  WidgetSettingsRoot,
  WidgetSettingsCollapsibleSection,
  SettingsSelect,
  SettingsRow,
} from '../form/settings.Widget';

export const LinkFullSettings = props => {
  const { linkId } = props;
  const link = useSelector(state => state.items?.[linkId]);
  const currentTab = useSelector(state => state.global.currentTab);
  const tab = useSelector(state => state.items?.[currentTab]);

  const gridTabIds = useMemo(() => {
    if (!Array.isArray(link?.tabs)) {
      return [];
    }
    return link.tabs
      .map(tabObj => {
        const tabId = getId(tabObj);
        const display = tabObj?.[tabId]?.display;
        if (display && display !== 'grid') {
          return null;
        }
        return tabId;
      })
      .filter(Boolean);
  }, [link?.tabs]);
  const tabs = useItems(gridTabIds);
  const tabLabelById = useMemo(() => {
    const map = new Map();
    tabs?.forEach(tabItem => {
      if (tabItem?._id) {
        map.set(tabItem._id, tabItem.label);
      }
    });
    return map;
  }, [tabs]);

  const [selectedTabId, setSelectedTabId] = useState('sidebar');

  useEffect(() => {
    if (!tab?.grid) {
      return;
    }
    const entry = tab.grid.find(element => element[linkId]);
    const stored = entry?.[linkId]?.fullTabId || 'sidebar';
    setSelectedTabId(stored);
  }, [tab, linkId]);

  return (
    <ModalGlobal
      title={"Paramètres de " + (link?.label || 'item')}
      idToOpen={'linkFull' + linkId}
    >
      <WidgetSettingsRoot>
        <WidgetSettingsCollapsibleSection title='Général' defaultOpen={true}>
          <SettingsRow label='Onglet affiché' dense>
            <SettingsSelect
              value={selectedTabId}
              onChange={event => {
                const nextValue = event.target.value;
                setSelectedTabId(nextValue);
                if (tab) {
                  updateField(tab, tab?.type, nextValue, linkId, 'fullTabId');
                }
              }}
            >
              <option value='sidebar'>Sidebar (par défaut)</option>
              {gridTabIds.map(tabId => (
                <option
                  key={tabId}
                  value={tabId}
                >
                  {tabLabelById.get(tabId) || tabId}
                </option>
              ))}
            </SettingsSelect>
          </SettingsRow>
        </WidgetSettingsCollapsibleSection>
      </WidgetSettingsRoot>
    </ModalGlobal>
  );
};
